<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-card-title class="titulopagina">ADMINISTRAR FORMULAS DE PARÁMETROS</v-card-title>
            </v-card-text>
            <v-row>
                <v-col cols="6">
                    <v-btn color="green" fab small dark @click="crear">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="6">
                    <p><small>Recalcular parámetros con fórmulas en bitácoras (no seleccionar más de 7 dias)</small></p>
                    <date-picker class="ml-2" v-model="rango_fechas" placeholder="Seleccione Fechas a recalcular" range format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    <v-btn small color="green darken-1" class="ml-2 mr-2 text-center" dark @click.stop="recalculaFormulas()">
                        <v-icon>cog</v-icon> Recalcular
                    </v-btn>
                </v-col>
            </v-row>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
        </v-card>

        <!-- <data-table class="mt-5" @editar="editar($event)"></data-table> -->
        <data-table-filtro class="mt-5" @editar="editar($event)"></data-table-filtro>


        <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
// import Data_Table from '@/components/shared/Data_Table.vue';
import Data_Table_Filtro from '../../components/shared/Data_Table_Filtro.vue'
import Modal from '@/components/shared/Modal.vue';
// import axios from 'axios'

//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    data:()=>({
        lista:[],
        puntos_medicion:[],
        rango_fechas:'',
        tipo_valores:[{id:'indicador',texto:'Indicador'},{id:'numero',texto:'Numero'},{id:'anterior',texto:'Anterior'}],
        operadores:[{id:'+',texto:'+'},{id:'-',texto:'-'},{id:'/',texto:'/'}],
        inputs:[
            {tipo:'select_loadable',valor:'',label:'Seleccione Punto de Medición*',key:'punto_mediciones_id',opciones:[],texto:'nombre_punto',seleccion:'id',ruta_opciones:'punto_medicion/parametros/',select_a_cargar:1},
            {tipo:'select',valor:'',label:'Seleccione Parámetro*',key:'parametro_detalles_id',opciones:[],texto:'texto',seleccion:'id'},
            {tipo:'select',valor:'',label:'Seleccione Tipo Valor 1*',key:'valor1',opciones:[],texto:'texto',seleccion:'id'},
            {tipo:'numero',valor:'',label:'Valor 1*',key:'parametro_detalles_id1'},
            {tipo:'select',valor:'',label:'Seleccione Operador*',key:'operador',opciones:[],texto:'texto',seleccion:'id'},
            {tipo:'select',valor:'',label:'Seleccione Tipo Valor 2*',key:'valor2',opciones:[],texto:'texto',seleccion:'id'},
            {tipo:'numero',valor:'',label:'Valor 2*',key:'parametro_detalles_id2'},
            {tipo:'numero',valor:'',label:'Orden*',key:'orden'}
            // {tipo:'select',valor:'',label:'Seleccione Unidad de Medida*',key:'unidad_medidas_id',opciones:[],texto:'unidad_medida',seleccion:'id'},
            // {tipo:'numero',valor:'',label:'Orden*',key:'orden'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
            {
                text:'Punto Medición',
                align:'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value:'parametro_detalle.punto_mediciones.nombre_punto',
                class:'cabecera'
            },
            {
                text:'T. Equipo',
                align:'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value:'parametro_detalle.equipos_procesos.tipo_equipo.tipo_equipo',
                class:'cabecera'
            },
            {
                text:'Equipo',
                align:'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value:'parametro_detalle.equipos_procesos.nombre_equipo',
                class:'cabecera'
            },
            {
                text:'Parametro',
                align:'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value:'parametro_detalle.parametros.nombre_parametro',
                class:'cabecera'
            },
            {
                text: 'Tipo Valor 1',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'valor1',
                class:'cabecera',
            },
            {
                text: 'Valor 1',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'parametro_detalles_id1',
                class:'cabecera',
            },
            {
                text: 'Parametro 1',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'parametro_1',
                class:'cabecera',
            },
            {
                text: 'Operador',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'operador',
                class:'cabecera',
            },
            {
                text: 'Tipo Valor 2',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'valor2',
                class:'cabecera',
            },
            {
                text: 'Valor 2',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'parametro_detalles_id2',
                class:'cabecera',
            },
            {
                text: 'Parametro 2',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'parametro_2',
                class:'cabecera',
            },
            {
                text: 'Orden',
                align: 'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value: 'orden',
                class:'cabecera',
            },
            {  
                text: 'Acciones', 
                value: 'action',
                sortable:false,
                filterable:false, align:'center' ,
                class:'cabecera'
            },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.inputs[2].opciones = this.tipo_valores;
        this.inputs[5].opciones = this.tipo_valores;
        this.inputs[4].opciones = this.operadores;

        this.cargarPuntosMedicion();
    },
    methods: {
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}parametro_formulas`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones);
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarPuntosMedicion(){
            //this.mostrarLoading('Cargando Puntos de Medición...');
            this.mostrarLoading({titulo:'Cargando Puntos de Medición...',color:'green'})

            let url = `${this.base_url}punto_medicion`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.puntos_medicion = response.data.data;
                this.inputs[0].opciones = this.puntos_medicion;
                this.cargarDatos();
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async cargarParametroDetalle(){
            await this.axios.get(url,this.headers).then((response)=>{
                response.data.data.forEach(opc => {
                    parametros.push({id:opc.id,texto:`${opc.id} - ${opc.equipos_procesos.nombre_equipo} - ${opc.parametros.nombre_parametro}`});
                });
                this.inputs[1].opciones = parametros;
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Paso de Formula';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'parametro_formulas';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            let punto_medicion = await this.$buscarObjeto($event['parametro_detalle']['punto_mediciones_id'],this.puntos_medicion);
            console.log('punto_medicion',punto_medicion);
            this.inputs[0].valor = punto_medicion;
            let url = `${this.base_url}punto_medicion/parametros/${punto_medicion.id}`;
            let parametros = [];
            await this.axios.get(url,this.headers).then((response)=>{
                response.data.data.forEach(opc => {
                    parametros.push({id:opc.id,texto:`${opc.id} - ${opc.equipos_procesos.nombre_equipo} - ${opc.parametros.nombre_parametro}`});
                });
                this.inputs[1].opciones = parametros;
            });
            let indicador = await this.$buscarObjeto($event['parametro_detalles_id'],parametros);
            this.inputs[1].valor = indicador;

            let tipo_valor = await this.$buscarObjeto($event['valor1'],this.tipo_valores);
            this.inputs[2].valor = tipo_valor;

            let tipo_valor_2 = await this.$buscarObjeto($event['valor2'],this.tipo_valores);
            this.inputs[5].valor = tipo_valor_2;

            let operador = await this.$buscarObjeto($event['operador'],this.operadores);
            this.inputs[4].valor = operador;

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Paso de Formula de Parámetro';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `parametro_formulas/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async recalculaFormulas(){
          console.log('rango fechas',this.rango_fechas);
          if(this.rango_fechas){
            this.mostrarLoading({titulo:'Recalculando Formulas...',color:'green'})

            let inicio = this.rango_fechas[0];
            let termino = this.rango_fechas[1];
            let url = `${this.base_url}recalcular_formulas/${inicio}/${termino}`;
            await this.axios.get(url, this.headers).then((response)=>{
              console.log(response.data.data);
              this.ocultarLoading();
              this.mostrarLoading({titulo:'Cálculos finalizados...' + response.data.data ,color:'green'})
            }).catch((error)=>{
              console.log('error', error);
              this.ocultarLoading();
              this.mostrarLoading({titulo:error,color:'red'})
            });
          }
        },

        ...mapMutations(['mostrarLoading','ocultarLoading']),
    },
    computed: {
        ...mapState(['base_url','headers']),
    },
    components:{
        'modal':Modal,
        'data-table-filtro':Data_Table_Filtro,
        DatePicker
        // 'data-table':Data_Table
    }
}
</script>